import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';

const Presets: React.FC = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'center',
                pt: 4,
            }}
        >
            <Typography variant="h6">Coming soon!</Typography>
        </Box>
    );
};

export default memo(Presets);
